export const footerTabConstants = {
    id : 7,
    pageType : "5006",
    pageName : "footerTabs"

}